import { Injectable } from '@angular/core';
import * as ui from "../../../models/ui";

import {TicketQuotaMessage, TicketQuotaAction, BulkTicket} from "../../../models";

@Injectable()
export class TicketQuotaMessageService {

	private ADD_TO_TICKETQUOTA_ACTION:string = ".bulk.AddToTicketQuotaAction"
	private REMOVE_FROM_TICKETQUOTA_ACTION = ".bulk.RemoveFromTicketQuotaAction"

	public createTicketQuotaMessage(ticketQuotaMessageEditor:ui.TicketQuotaMessageEditor):TicketQuotaMessage {
		return {
			actions: this.createTicketQuotaActions(ticketQuotaMessageEditor.ticketQuotaMessageEditorActions),
			comment: ticketQuotaMessageEditor.comment,
			date: ticketQuotaMessageEditor.date,
			name: ticketQuotaMessageEditor.name
		}
	}

	private createTicketQuotaActions(ticketQuotaMessageEditorActions:ui.TicketQuotaMessageEditorAction[]):TicketQuotaAction[] {
		let actions: TicketQuotaAction[] = []
		let pos:number = 0
		ticketQuotaMessageEditorActions.forEach(editorAction => {
			let type:string = ""
			let bulkTicketNumberOfTickets = Math.abs(editorAction.numberOfTicketsToAddDelete)

			if (editorAction.numberOfTicketsToAddDelete && editorAction.numberOfTicketsToAddDelete != 0) {
				if (editorAction.numberOfTicketsToAddDelete < 0) {
					type = this.REMOVE_FROM_TICKETQUOTA_ACTION
				} else if (editorAction.numberOfTicketsToAddDelete > 0) {
					type = this.ADD_TO_TICKETQUOTA_ACTION
				}

				let ticketQuotaAction:TicketQuotaAction = {
					type: type,
					pos:pos,
					bulkTicket: {
						category:editorAction.category,
						numberOfTickets:bulkTicketNumberOfTickets
					}
				}
				actions.push(ticketQuotaAction)

				pos = pos+1
			}
		})
		return actions
	}
}


// WEBPACK FOOTER //
// ./src/app/components/event-components/ticket-quota-collection/ticket-quota-message-service.ts